var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultilineText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44655_242891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 0.5H5C2.79086 0.5 1 2.29086 1 4.5V67.5C1 69.7091 2.79086 71.5 5 71.5H68C70.2091 71.5 72 69.7091 72 67.5V4.5C72 2.29086 70.2091 0.5 68 0.5Z",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 56H11C10.7239 56 10.5 56.2239 10.5 56.5C10.5 56.7761 10.7239 57 11 57H62C62.2761 57 62.5 56.7761 62.5 56.5C62.5 56.2239 62.2761 56 62 56Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 31.7266H62.5",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 37.7266H62.5",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 43.7266H62.5",
    stroke: "#4D4D4D",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2393 17C39.8896 17 40.4249 17.4805 40.4934 18.0979L40.5008 18.2321V23.0813C40.5008 23.7618 39.936 24.3134 39.2393 24.3134C38.5891 24.3134 38.0537 23.8329 37.9852 23.2155L37.9778 23.0813L37.9768 19.4643H14.023V23.0813C14.023 23.7164 13.531 24.2393 12.8989 24.3062L12.7615 24.3134C12.1112 24.3134 11.5759 23.8329 11.5074 23.2155L11.5 23.0813V18.2321C11.5 17.597 11.992 17.0741 12.624 17.0072L12.7615 17H39.2393Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9651 42.8633C31.6618 42.8633 32.2266 43.4149 32.2266 44.0954C32.2266 44.7306 31.7346 45.2534 31.1025 45.3203L30.9651 45.3276H21.0359C20.3392 45.3276 19.7744 44.7759 19.7744 44.0954C19.7744 43.4603 20.2664 42.9374 20.8984 42.8705L21.0359 42.8633H30.9651Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 17C26.6505 17 27.1858 17.4805 27.2543 18.0979L27.2617 18.2321V44.0942C27.2617 44.7747 26.6969 45.3264 26.0002 45.3264C25.35 45.3264 24.8147 44.8458 24.7462 44.2285L24.7388 44.0942V18.2321C24.7388 17.5516 25.3036 17 26.0002 17Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2393 17C39.8896 17 40.4249 17.4805 40.4934 18.0979L40.5008 18.2321V23.0813C40.5008 23.7618 39.936 24.3134 39.2393 24.3134C38.5891 24.3134 38.0537 23.8329 37.9852 23.2155L37.9778 23.0813L37.9768 19.4643H14.023V23.0813C14.023 23.7164 13.531 24.2393 12.8989 24.3062L12.7615 24.3134C12.1112 24.3134 11.5759 23.8329 11.5074 23.2155L11.5 23.0813V18.2321C11.5 17.597 11.992 17.0741 12.624 17.0072L12.7615 17H39.2393Z",
    fill: "#4D4D4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9651 42.8633C31.6618 42.8633 32.2266 43.4149 32.2266 44.0954C32.2266 44.7306 31.7346 45.2534 31.1025 45.3203L30.9651 45.3276H21.0359C20.3392 45.3276 19.7744 44.7759 19.7744 44.0954C19.7744 43.4603 20.2664 42.9374 20.8984 42.8705L21.0359 42.8633H30.9651Z",
    fill: "#4D4D4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0002 17C26.6505 17 27.1858 17.4805 27.2543 18.0979L27.2617 18.2321V44.0942C27.2617 44.7747 26.6969 45.3264 26.0002 45.3264C25.35 45.3264 24.8147 44.8458 24.7462 44.2285L24.7388 44.0942V18.2321C24.7388 17.5516 25.3036 17 26.0002 17Z",
    fill: "#4D4D4D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44655_242891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultilineText);
export default __webpack_public_path__ + "static/media/multiline-text.383fa26f446493d4e0369a1828e64e0b.svg";
export { ForwardRef as ReactComponent };